import {_utils} from "../../../utils/_utils.js";
import {_libs} from "../../../utils/_libs.js";
import {gsap} from "gsap";

export const serviceFlow = () => {
    return new Promise((resolve) => {
        _utils.initSection('.service-flow', (section) => init(section));
        resolve();
    })
}

const init = (section) => {
    const stage = section.querySelector('[data-sf-stage]');
    const cards = section.querySelectorAll('[data-sf-card]');
    const header = document.querySelector('#header');

    if (!stage || !cards.length) return;

    let tl = null;

    const createTL = () => {
        if (tl) {
            if (tl.scrollTrigger) tl.scrollTrigger.kill(true);
            tl.kill();
            tl = null;
        }

        // Revert to the CSS resting state (cards stacked via --tx on desktop, plain on mobile).
        gsap.set(cards, {clearProps: 'transform'});
        // Reset the header (avoids a stuck "move-up" if we rebuild while inside the section).
        header?.classList.remove('move-up');

        // Animate only on desktop — the wrapper is pinned via CSS position:sticky (no ScrollTrigger pin).
        if (!window.matchMedia('(min-width: 1025px)').matches) return;

        // Custom pin-spacer is the tall stage; scrub the cards from their stacked offset to place.
        // Hide the header while the pinned animation is on screen, reveal it once we're past it.
        tl = _libs._gsap({
            trigger: stage,
            start: 'top top',
            end: 'bottom bottom',
            scrub: true,
            onEnter: () => header?.classList.add('move-up'),
            onEnterBack: () => header?.classList.add('move-up'),
            onLeave: () => header?.classList.remove('move-up'),
            onLeaveBack: () => header?.classList.remove('move-up'),
        });

        tl.to(cards, {x: 0, ease: 'none'}, 0);
    }

    createTL();

    _utils.rebuildComponentsOnResize(() => createTL());
}
